
















import { UnsubscribedPaidMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { DateFormat } from '@/util/format'
import BaseState from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/BaseState.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PlanSubscribingPeriod from './molecules/PlanSubscribingPeriod.vue'

/**
 * 解約済みの場合
 */
@Component({
  components: { PlanSubscribingPeriod, BaseState },
})
export default class Unsubscribed extends Vue {
  @Prop({ required: true })
  readonly plan: UnsubscribedPaidMembershipPlan

  readonly formatDate = DateFormat.yyyyMmDd
}
